import React from "react";
import SectionBlock from "../../../../global/components/FeatureCard/SectionBlock";
import backupScheduling from "../../../../assets/images/backupRestore/backup-scheduling.png";
import dataRestoration from "../../../../assets/images/backupRestore/data-restoration.png";

const PAGE_X = "px-6 lg:px-[120px]";

const sections = [
  {
    image: backupScheduling,
    label: "Automated Backup Scheduling and Data Protection",
    description:
      "The Backup Schedule feature enables administrators to configure automated, recurring backups across local media, FTP servers, and cloud storage. Organizations define granular backup policies by selecting specific data categories—All Data, Node DB, System DB, Log DB, or Image Files—with customizable time intervals (daily, weekly, monthly) ensuring continuous data protection without manual intervention. The system automatically generates timestamped backup files using YYYYMMDDHHMMSS format for precise version control and recovery point identification. Multiple concurrent backup schedules support diverse retention policies, allowing administrators to maintain short-term operational backups alongside long-term archival copies for comprehensive data protection across distributed access control infrastructure.",
    imageLeft: true,
    imageBg: "#ffffff",
    textBg: "#f8f8f8",
    bodyColor: "#5b5b5b",
    imageMaxWidth: "590px",
    sectionHeight: "540px",
  },
  {
    image: dataRestoration,
    label: "Comprehensive Data Restoration and Recovery",
    description:
      "The Restore feature delivers flexible recovery options to restore system data from previously created backups, ensuring business continuity following hardware failures, data corruption, or accidental deletions. The restoration process supports selective data recovery, empowering administrators to restore complete system snapshots or specific database components based on operational requirements. Media selection offers recovery from local storage, network FTP servers, or cloud repositories, providing geographic redundancy and rock-solid disaster recovery capabilities. The interface presents available backup files with timestamps for accurate recovery point selection, while the restore operation validates data integrity before applying changes to minimize downtime and ensure configuration consistency.",
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#f8f8f8",
    bodyColor: "#5b5b5b",
    imageMaxWidth: "590px",
    sectionHeight: "640px",
    textAlign: "right",
  },
];

export const BackupRestoreContent = () => (
  <div className="bg-white w-full">
    <section
      className={`bg-white flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
    >
      <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[1004px]">
        Automated Backup & Recovery
      </h1>
      <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal max-w-[792px]">
        Protect critical system data with scheduled backups, secure storage
        options, and reliable recovery across your entire access control
        infrastructure.
      </p>
    </section>

    <div className="w-full bg-white mt-6">
      {sections.map((section) => (
        <SectionBlock key={section.label} {...section} />
      ))}
    </div>
  </div>
);
